import { useState, type FormEvent } from 'react';

/**
 * Sticky bottom add bar — 40px pill (radius 20) plus a 40px circular send
 * button. Rendered only for owner/editor; a viewer never sees it.
 */
export function AddItemBar({
  onAdd,
  disabled,
}: {
  onAdd: (text: string) => void;
  disabled?: boolean;
}) {
  const [text, setText] = useState('');

  function submit(e: FormEvent) {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    setText('');
  }

  return (
    <form className="add-bar" onSubmit={submit}>
      <div className="add-bar__inner">
        <input
          className="add-bar__input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add an item, use #tag for a category"
          aria-label="Add an item"
          disabled={disabled}
        />
        <button
          type="submit"
          className="add-bar__send"
          aria-label="Add item"
          disabled={disabled || !text.trim()}
        >
          ➤
        </button>
      </div>
    </form>
  );
}
